// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";
import { SchemaTable, Col, Row, View } from "@components";

type OwnProps = $Exact<{
  title: String,
  data: Object,
  schema: Object,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export const CommonAlertsView = (props: Props) => {
  return (
    <View>
      <h6>{props.title}</h6>
      <SchemaTable
        tableData={props.data}
        schema={props.schema}
        uiSchema={{
          "ui:order": ["label"],
          label: {
            "ui:title": "Alert Configurations",
            "ui:widget": "text",
            "ui:options": {
              editable: false,
              minWidth: "85%",
            },
          },
        }}
      />
    </View>
  );
};

export default localize()(CommonAlertsView);
